<template>
  <div>
    <v-dialog v-model="show" persistent max-width="800" scrollable>
      <v-card flat>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1" flat dark height="50px">
            <v-tooltip bottom v-if="widgetData.title && widgetData.title.length > 86">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on" style="
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-size: 16px;
                  ">{{ widgetData.title }}</span>
              </template>
              <span>{{ widgetData.title }}</span>
            </v-tooltip>
            <span v-else style="
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-size: 16px;
              ">
              {{ widgetData.title }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="show = false" />
          </v-toolbar>
        </v-banner>
        <v-card-text style="min-height: 200px; max-height: 70vh;" v-html="widgetData.caption">
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ViewDocumentCaption",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    widgetData: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
  },
};

</script>
